<template>
    <div class="single-upload">
        <!-- 未上传状态 -->
        <el-upload v-if="!modelValue" class="upload-box" :show-file-list="false" :before-upload="beforeUpload"
            :http-request="handleUpload" accept="image/*">
            <div class="upload-btn">
                <el-icon>
                    <Plus />
                </el-icon>
                <p>上传图片</p>
            </div>
        </el-upload>

        <!-- 已上传状态 -->
        <div v-else class="uploaded-image">
            <img :src="modelValue" alt="uploaded" @click="triggerReplace" loading="lazy" />
            <div class="overlay" @click="triggerReplace">
                <el-icon>
                    <Edit />
                </el-icon>
                <span>点击替换</span>
            </div>
            <button class="delete-btn" @click.stop="removeImage">
                <el-icon>
                    <Delete />
                </el-icon>
            </button>

            <!-- 隐藏 input，用于重新选择 -->
            <input ref="fileInput" type="file" accept="image/*" class="hidden-input" @change="replaceImage" />
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { ElMessage } from "element-plus";
import { apiUpload } from "@/utils/api";

const props = defineProps({
    modelValue: { type: String, default: "" },
})
const emit = defineEmits(["update:modelValue"]);

const fileInput = ref(null);

const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isImage) ElMessage.error("只能上传图片文件");
    if (!isLt2M) ElMessage.error("图片大小不能超过 2MB");

    return isImage && isLt2M;
}

const handleUpload = async ({ file }) => {
    const formData = new FormData();
    formData.append("files", file);

    const response = await apiUpload(formData);
    emit("update:modelValue", response.fileUrl);
}

const triggerReplace = () => {
    fileInput.value.click();
}

const replaceImage = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
        ElMessage.error("请选择图片文件");
        return;
    }

    handleUpload({file});
}

const removeImage = () => {
    emit("update:modelValue", "");
}
</script>

<style scoped>
.single-upload {
    display: flex;
    justify-content: center;
    align-items: center;
}

.upload-box {
    width: 180px;
    height: 240px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transition: all 0.2s;
}

.upload-box:hover {
    border-color: #409eff;
}

.upload-btn {
    text-align: center;
    color: #909399;
}

.uploaded-image {
    position: relative;
    width: 180px;
    height: 240px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
}

.uploaded-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.uploaded-image:hover img {
    transform: scale(1.05);
}

/* 覆盖层 */
.overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    font-size: 14px;
}

.uploaded-image:hover .overlay {
    opacity: 1;
}

/* 删除按钮 */
.delete-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
}

.uploaded-image:hover .delete-btn {
    opacity: 1;
}

.hidden-input {
    display: none;
}
</style>
